import Vue from 'vue'
import store from '..'
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  namespaced: true,
  state () {
    return {
      tags: [],
      reference: null,
      initial: {
        key: null,
        name: null,
        category: null,
        color: '#1976D2FF',
        schools: {},
        createdAt: null,
        updatedAt: null
      }
    }
  },
  getters: {
    tags (state) {
      return state.tags
    },
    reference (state) {
      return state.reference
    },
    initial (state) {
      return state.initial
    }
  },
  mutations: {
    init (state, payload) {
      state.tags = payload
    },
    add (state, payload) {
      state.tags.push(payload)
    },
    update (state, payload) {
      const index = state.tags.findIndex(schola => schola.key === payload.key)
      if (index !== -1) {
        Vue.set(state.tags, index, payload)
      }
    },
    remove (state, payload) {
      const index = state.tags.findIndex(tag => tag.key === payload.key)
      if (index !== -1) {
        state.tags.splice(index, 1)
      }
    },
    reference (state, payload) {
      state.reference = payload
    }
  },
  actions: {
    init ({ commit }) {
      return new Promise((resolve) => {
        commit('init', [])
        resolve()
      })
    },
    subscribe ({ commit }, payload) {
      var boot = true
      var temp = []
      return new Promise((resolve, reject) => {
        commit('init', [])
        const db = firebase.firestore()
        var dbRef = db.collection('tags')
        var reference = null
        if (payload) {
          reference = dbRef.where('schools.' + payload, '==', true).onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        } else {
          reference = dbRef.onSnapshot(snapshots => {
            if (snapshots.empty) {
              resolve()
            }
            snapshots.docChanges().forEach(change => {
              var data = JSON.parse(JSON.stringify(change.doc.data()))
              if (boot && change.type === 'added') {
                temp.push(data)
              } else if (change.type === 'added') {
                commit('add', data)
              } else if (change.type === 'modified') {
                commit('update', data)
              } else if (change.type === 'removed') {
                commit('remove', data)
              }
            })
            if (boot) {
              boot = false
              commit('init', temp)
            }
            resolve()
          })
        }
        commit('reference', reference)
      })
    },
    unSubscribe ({ commit }) {
      var reference = store.getters['tags/reference']
      return new Promise((resolve) => {
        if (reference) {
          reference()
          commit('reference', null)
          commit('init', [])
          resolve()
        } else {
          resolve()
        }
      })
    },
    write ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        var ref = null
        if (payload.key) {
          ref = db.collection('tags').doc(payload.key)
        } else {
          ref = db.collection('tags').doc()
          payload.key = ref.id
        }
        ref.set(payload)
          .then(function () {
            // console.log('Document successfully written!')
            resolve(ref.id)
          })
          .catch(function (error) {
            if (error) {
            // console.error('Error writing document: ', error)
            }
            resolve()
          })
      })
    },
    delete ({ commit }, payload) {
      return new Promise((resolve) => {
        const db = firebase.firestore()
        db.collection('tags').doc(payload).delete().then(function () {
          // console.log('Document successfully deleted!')
          resolve()
        }).catch(function (error) {
          if (error) {
            // console.error('Error removing document: ', error)
          }
          resolve()
        })
      })
    }
  }
}
